<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure-nxt"> </p>
<p class="White_Quote">The joy of life comes from our encounters with new<span class="noBreak"> </span>experiences.</p>
<p class="QuoteAuthor_White">—Jon Krakauer</p>
<p class="Yellow_Quote">Each day is an adventure in discovering the meaning of<span class="noBreak"> </span>life.</p>
<p class="QuoteAuthor_Yellow">—Jack Canfield</p>
<p class="White_Quote">It is good to have an end to journey toward;<br/>but it is the journey that matters, in the<span class="noBreak"> </span>end.</p>
<p class="QuoteAuthor_White">—Ursula K. Le Guin</p>
<p class="Yellow_Quote">To awaken quite alone in a strange town is one of the most pleasant sensations in the world.<br/>You are surrounded by<span class="noBreak"> </span>adventure.</p>
<p class="QuoteAuthor_Yellow"><a id="_idTextAnchor057"></a>—Freya Stark</p>
<p class="White_Quote">My favorite thing is to go where I’ve never<span class="noBreak"> </span>been.</p>
<p class="QuoteAuthor_White">—Diane Arbus</p>
<p class="Yellow_Quote">The voyage of discovery is not in seeking new landscapes,<br/>but in having new<span class="noBreak"> </span>eyes.</p>
<p class="QuoteAuthor_Yellow">—Marcel Proust</p>
<p class="White_Quote">Stuff your eyes with wonder, live as if you’d drop dead in ten seconds. See the world. It’s more fantastic than any dream made or paid for in<span class="noBreak"> </span>factories.</p>
<p class="QuoteAuthor_White">—Ray Bradbury</p>
<p class="Yellow_Quote">A mind that is stretched by a new experience<br/>can never go back to its old<span class="noBreak"> </span>dimensions.</p>
<p class="QuoteAuthor_Yellow">—Oliver Wendell Holmes</p>
<p class="White_Quote">There is no greater joy than to have an endlessly changing horizon, for each day to have a new and different<span class="noBreak"> </span>sun.</p>
<p class="QuoteAuthor_White">—Chris McCandless</p>
<p class="Yellow_Quote">The most fulfilling adventures happen when you start your journey without knowing where you’re going, because only then are you free to experience the unexpected detours you’re meant to<span class="noBreak"> </span>take.</p>
<p class="QuoteAuthor_Yellow">—A. J. Darkholme</p>
<p class="White_Quote">Life is either a great adventure or<span class="noBreak"> </span>nothing.</p>
<p class="QuoteAuthor_White">—Helen Keller</p>
<p class="Yellow_Quote">May your trails be crooked, winding, lonesome, dangerous, leading to the most amazing<span class="noBreak"> </span>view.</p>
<p class="QuoteAuthor_Yellow">—Edward Abbey</p>
<p class="White_Quote">Life is adventure, not<span class="noBreak"> </span>predicament.</p>
<p class="QuoteAuthor_White">—James Broughton</p>
<p class="Yellow_Quote">Twenty years from now you will be more disappointed by the things you didn’t do than by the ones you did do. So throw off the bowlines. Sail away from the safe harbor. Catch the trade winds in your sails. Explore. Dream. Discover.</p>
<p class="QuoteAuthor_Yellow">—H. Jackson Brown Jr.</p>
<p class="White_Quote">Each thing she learned became a part of herself<br/>to be used over and over in new<span class="noBreak"> </span>adventures.</p>
<p class="QuoteAuthor_White">—Kate Seredy</p>
<p class="Yellow_Quote">Serendipity. Look for something, find something else, and realize that what you’ve found is more suited to your needs than what you thought you were looking<span class="noBreak"> </span>for.</p>
<p class="QuoteAuthor_Yellow">—Lawrence Block</p>
<p class="White_Quote">Adventure isn’t hanging on a rope off the side of a mountain. Adventure is an attitude that we must apply to the day to day obstacles of life—facing new challenges, seizing new opportunities, testing our resources against the unknown and in the process, discovering our own unique<span class="noBreak"> </span>potential.</p>
<p class="QuoteAuthor_White">—John Amatt</p>
<p class="Yellow_Quote">Adventure is worthwhile in<span class="noBreak"> </span>itself.</p>
<p class="QuoteAuthor_Yellow">—Amelia Earhart</p>
<p class="White_Quote">I think over again my small adventures, my fears,<br/>These small ones that seemed so big.<br/>For all those vital things I had to get and to reach.<br/>And yet there is only one great thing,<br/>The only thing.<br/>To live and see the great day that dawns<br/>And the light that fills the<span class="noBreak"> </span>world.</p>
<p class="QuoteAuthor_White _idGenParaOverride-1">—Inuit Song</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816425039448.vue?6b51fb31